import { render, staticRenderFns } from "./CASEEntityHistory.vue?vue&type=template&id=5382ed2e"
import script from "./CASEEntityHistory.vue?vue&type=script&lang=js"
export * from "./CASEEntityHistory.vue?vue&type=script&lang=js"
import style0 from "./CASEEntityHistory.vue?vue&type=style&index=0&id=5382ed2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports